export default __webpack_public_path__ + "static/media/saved-icon-filled.582d1128.svg";